import { createApp } from "vue";
import App from "@/App.vue";
import router from "@/router";
import store from "@/store";
import "../src/index.css";
import Vue from "vue"
import mitt from 'mitt'
import axios from "axios";
import Aura from '@primevue/themes/aura';
import PrimeVue from 'primevue/config';
// import "../node_modules/@vueform/multiselect/themes/default.css"
import "vue-multiselect/dist/vue-multiselect.css"
import Toast, { PluginOptions } from "vue-toastification";
import "vue-toastification/dist/index.css";


import { useToast } from "vue-toastification";
export const toast = useToast();
export const emitter = mitt();

const instance = axios.create({
    withCredentials: true,
});
  
instance.interceptors.request.use(function(config:any) {
    const token = localStorage.getItem('AUTH_ID');
    if(token) {
        // config.headers.common["Authorization"] = 'Bearer ' + token;  
        config.headers.Authorization  = 'Bearer ' + token;  
    }
    return config;
}, function(err:any) {
    return Promise.reject(err);
});

instance.interceptors.response.use((response) => {
    return response;
  }, (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('authToken'); 
      // window.location.href = "http://localhost:8080"; 
      window.location.href = `${process.env.VUE_APP_AUTH_WEBAPP_URL}/session?returnTo=${process.env.VUE_APP_DMS_WEBAPP_URL}`; 

    }
    return Promise.reject(error);
  });
  
const app = createApp(App)
app.config.globalProperties.$http = instance;
app.use(store).use(router).use(Toast).use(PrimeVue, {theme: {preset: Aura, options: {
    darkModeSelector: '.my-app-dark',
}}}).mount("#app");